import React, { useContext } from "react";
import { RootStoreContext } from "../../app/stores/rootStore";

const FilterFormInfo = () => {
  const rootStore = useContext(RootStoreContext);
  const { getFilterInfo } = rootStore.trackPayrollStore;

  return (
    <div      
      dangerouslySetInnerHTML={{ __html: getFilterInfo() }}
    ></div>
  );
};

export default FilterFormInfo;
